export default "__VITE_ASSET__B6ZIk7TH__"